import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type CreateAssetApiResponse } from '../services/createAssetService'

export interface CreateAssetState {
  isLoading: boolean
  error: string | undefined
  data: CreateAssetApiResponse | undefined
  httpStatus: number | undefined
}

export const initialState: CreateAssetState = {
  isLoading: false,
  error: undefined,
  data: undefined,
  httpStatus: 0
}

const createAssetSlice = createSlice({
  name: 'CreateAssetSlice',
  initialState,
  reducers: {
    createAssetLoadingAction: (state) => {
      return {
        isLoading: true,
        error: undefined,
        data: undefined,
        httpStatus: 0
      }
    },
    createAssetUpdateAction: (state, action: PayloadAction<{ data: CreateAssetApiResponse, httpStatus: number }>) => {
      return {
        isLoading: false,
        error: undefined,
        data: action.payload.data,
        httpStatus: action.payload.httpStatus
      }
    },
    createAssetErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number | undefined }>) => {
      return {
        isLoading: false,
        error: action.payload.errorMessage,
        data: undefined,
        httpStatus: action.payload.httpStatus
      }
    },
    reset: () => initialState
  }
})

export const {
  createAssetLoadingAction,
  createAssetUpdateAction,
  createAssetErrorAction,
  reset
} = createAssetSlice.actions

export default createAssetSlice.reducer
